import React, { Component } from 'react';
import { ToolbarRow } from './toolbar-row.js';
import styles from './toolbar.less.js';

class ToolbarGroup extends Component {
    render() {
        const { group, shelter, tooltipPlacement } = this.props;
        const rowCount = group.filter(row => row.length > 0).length;
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { id: group[0][0].name, className: styles['virtual-group'], "data-row-count": rowCount }, group
                .filter(row => row.length > 0)
                .map((row, i) => React.createElement(ToolbarRow, { key: i, row: row, tooltipPlacement: tooltipPlacement }))),
            shelter
                ? React.createElement("div", { className: styles['virtual-group'], "data-row-count": 1 },
                    React.createElement(ToolbarRow, { row: [shelter], tooltipPlacement: tooltipPlacement }))
                : null));
    }
}

export { ToolbarGroup };
//# sourceMappingURL=toolbar-group.js.map
